// Centralized API base URL for the frontend
// Priority: CRA env -> fallback to api.caelus.pl
export const API_URL = process.env.REACT_APP_API_URL || 'https://api.caelus.pl';

export function getApiBaseUrl() {
  return API_URL;
}

/**
 * Default handler for authentication errors
 * Can be overridden by passing handleAuthError parameter
 */
let defaultAuthErrorHandler = null;

export function setDefaultAuthErrorHandler(handler) {
  defaultAuthErrorHandler = handler;
}

/**
 * Wrapper around fetch that automatically handles authentication errors (401/403)
 * and redirects to login page when token expires
 */
export async function apiRequest(url, options = {}, handleAuthError) {
  const response = await fetch(url, options);
  
  // Handle authentication errors
  if (response.status === 401 || response.status === 403) {
    const handler = handleAuthError || defaultAuthErrorHandler;
    if (handler) {
      handler();
    } else {
      // Fallback: clear storage and redirect
      localStorage.removeItem('token');
      localStorage.removeItem('userData');
      if (window.location.pathname !== '/signin') {
        window.location.href = '/signin';
      }
    }
    // Return a rejected promise to stop execution
    throw new Error('Authentication failed');
  }
  
  return response;
}


